import { Stack, Typography } from "@mui/material";
import { usePersonalInformationValues } from "Components/Onboarding/hooks/usePersonalInformationValues";
import type { PersonalInformationConfirmationFormModel } from "Components/Onboarding/shared/PersonalInformation/schema";
import { ValueItems } from "Components/Onboarding/shared/ValueItems";
import { ValuesBox } from "Components/Onboarding/shared/ValuesBox";
import { BooleanRadioChoice } from "Components/Shared/Inputs/Form/BooleanRadioChoice";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import type { Control } from "react-hook-form";

const StepResources = Resources.Onboarding.Steps.PersonalInformation;

type Props = {
  onEdit: () => void;
  userDetail: PartyDto;
  control: Control<PersonalInformationConfirmationFormModel>;
  isIDScanConfirmationVisible: boolean;
  isIDScanMarkedAsIncorrect: boolean;
};

export const ViewValues = ({
  onEdit,
  userDetail,
  control,
  isIDScanConfirmationVisible,
  isIDScanMarkedAsIncorrect,
}: Props) => {
  const { t } = useResource();
  const { personalInfo, addressInfo, documentInfo } =
    usePersonalInformationValues(userDetail);

  return (
    <>
      <ValuesBox title={t(StepResources.FormGroups.IdentityDocument)}>
        <ValueItems values={documentInfo} />
        {isIDScanConfirmationVisible ? (
          <Stack display="flex" justifyContent="center" width="100%" mt={4}>
            <BooleanRadioChoice
              isInitiallyUndefined
              control={control}
              name="isIDCardApprovedByClient"
              label={t(Resources.PersonalInfo.ConfirmDataRequest)}
            />
            {isIDScanMarkedAsIncorrect && (
              <Typography>{t(StepResources.DataMarkedAsIncorrect)}</Typography>
            )}
          </Stack>
        ) : (
          <Typography>{t(StepResources.ScanIncomplete)}</Typography>
        )}
      </ValuesBox>
      <Stack gap={5}>
        <ValuesBox
          title={t(StepResources.FormGroups.PersonalInformation)}
          onEdit={onEdit}
          hideDivider
        >
          <ValueItems values={personalInfo} />
        </ValuesBox>
        <ValuesBox title={t(StepResources.FormGroups.Address)}>
          <ValueItems values={addressInfo} />
        </ValuesBox>
      </Stack>
    </>
  );
};
